"use client";
import { Quote } from "lucide-react";



export default function Reviews() {
  const reviews = [
    {
      review:
        "This organization is first class. They are honest, reliable, and do fantastic work. I have done business with them in the past and have always been more than happy. I would highly recommend them.",
      name: "Mirella F.",
      job: "Homeowner",
    },
    {
      review:
        "They did a great job on our house. They came, they did the work from start to finish without any delays, and our home looks great. I recommend them 100%",
      name: "John B.",
      job: "Business Owner",
    },
  ];

  return (
    <section
      id="reviews"
      className="w-full py-12 lg:py-[4.5rem] px-5 md:px-8 lg:px-0"
    >
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-12">
        {/* Top Content Section */}
        <div className="w-full flex flex-col items-center justify-center text-center">
          <span className="text-sm text-primary mb-2 block">
            Reviews from past clients
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            <span className="lg:text-[2.45rem] font-normal">
              Here's what our clients say
            </span>
          </h2>
        </div>

        {/* Reviews Grid */}
        <div className="w-full grid md:grid-cols-2 gap-4">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="border bg-card p-6 md:p-8 rounded-md flex flex-col"
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-primary mb-8" />

              {/* Review Text */}
              <p className="text-foreground text-base md:text-lg mb-8">
                <span>{review.review}</span>
              </p>

              {/* Author Info */}
              <div className="mt-auto">
                <span className="block text-lg md:text-xl font-bold text-foreground">
                  <span>{review.name}</span>
                </span>
                <span className="text-sm md:text-base text-foreground/80">
                  <span>{review.job}</span>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
